/**
 * @title addressVerification.js: Feature level module
 * @description Address verification module
 */
define(['address', 'addressDisplay'], function(address, addressDisplay) {
  let CAddressVerification = {
    entered: '',
    suggested: '',
    buildAddressVerificationModal: function(entered, suggested, result) {
      let verificationModal = $($('#tmpl_address_verification').html());
      // Need to create a temp object for extending through jQuery
      let tempEntered = JSON.parse(JSON.stringify(entered));
      let extendedSuggest = $.extend(tempEntered, suggested);
      if (result === 'ADDRESS_WRONG_NO_SUGGESTION') {
        let enteredHtml = addressDisplay.createAddressVerificationDisplay(entered, 'tmpl_address_display_verification');
        $(verificationModal).find('#entered-address .address').append(enteredHtml);
        $(verificationModal).find('#entered-address input').attr('tabindex', '-1');
        $(verificationModal).find('[role="radio"]').attr("aria-labelledby", "orderAddrVerfication_" + entered.id);
        $(verificationModal).find('#suggested-address').hide();
        $(verificationModal).find('#no-match').show();
        $(verificationModal).find('#address-verify-warningInfo-header').hide();
        $(verificationModal).find('#address-verify-warningInfo-header-no-match').show();
        COSTCO.CAddressVerification.entered = entered;
      } else {
        let enteredHtml = addressDisplay.createAddressVerificationDisplay(entered, 'tmpl_address_display_verification');
        $(verificationModal).find('#entered-address .address').append(enteredHtml);
        $(verificationModal).find('#entered-address input').attr('tabindex', '-1');
        $(verificationModal).find('[role="radio"]').attr("aria-labelledby",  "orderAddrVerfication_" + entered.id);
        let suggestedHtml = addressDisplay.createAddressVerificationDisplay(extendedSuggest, 'tmpl_address_display_verification');
        $(verificationModal).find('#suggested-address .address').append(suggestedHtml);
        $(verificationModal).find('#suggested-address input').attr('checked', 'true');
        $(verificationModal).find('#suggested-address input').parent().attr('aria-checked', 'true');
        $(verificationModal).find('#suggested-address input').attr('tabindex', '-1');
        if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isUSBDStore()) {
          if (!COSTCO.util.isNdEnabled() && "N" == suggested.isCommercial) {
            $(verificationModal).find('#address-modal-notification').text(messages.MODAL_ADDRESS_RESIDENTIAL_WARNING);
          }
        }
        COSTCO.CAddressVerification.entered = entered;
        COSTCO.CAddressVerification.suggested = extendedSuggest;
      }
      return verificationModal;
    },
    showAddressVerificationModal: function(addressObj, preventhtmlajax, addressOptions) {
      let suggested = addressObj.Validated_Address[0];
      let entered = addressObj.Address[0];
      let result = suggested.result;
      let modalBody = CAddressVerification.buildAddressVerificationModal(entered, suggested, result);
      let primaryDisabled = (result === 'ADDRESS_WRONG_NO_SUGGESTION');
      $('.order-ajax').removeClass('ajax-busy');
      if (typeof addressOptions.primaryEventCallback === 'undefined') {
        addressOptions.primaryEventCallback = CAddressVerification.useAddressCallback;
      }
      if (addressOptions.isModalStack) {
      	let labels = address.getHeaderLabels('S', 'verify');
      	COSTCO.dialog.modalStack({
          title: labels.modalTitle,
          body: modalBody,
          primary_event: function() {
	          addressOptions.primaryEventCallback(preventhtmlajax, addressOptions);
	        },
      		primaryDisabled: primaryDisabled,
          primary: labels.primaryButton,
          secondary: messages.JS_DIALOG_CANCEL
      	});
      }
      else {
	      address.baseModal(addressOptions.successCallback.arguments[1], 'verify', {
	        body: modalBody,
	        primary_event: function() {
	          addressOptions.primaryEventCallback(preventhtmlajax, addressOptions);
	        },
	        primaryDisabled: primaryDisabled,
	      });
      }
    },
    buildMultiAddressVerificationModal: function(addressObj) {
      let verificationModal = $($('#tmpl_multi_address_verification').html());
      $.each(addressObj.Address, function(index, value) {
        // If we only have 1 address, we won't show the label in the modal.
        value.numOfAddresses = addressObj.Address.length;
        let entered = addressObj.Address[index];
        let suggested = CAddressVerification.matchValidatedAddress(value.id, addressObj.Validated_Address);
        let verificationLineBlockHtml = '';
        if (suggested.result != 'ADDRESS_WRONG_NO_SUGGESTION') {
	      let tempEntered = JSON.parse(JSON.stringify(entered));
	      let extendedSuggest = $.extend(tempEntered, suggested);
	      let enteredHtml = addressDisplay.createAddressVerificationDisplay(entered, 'tmpl_multi_address_verification_display_addr_element');
	      verificationLineBlockHtml = $(COSTCO.util.tmpl('tmpl_multi_address_verification_line_block', value));
	      $(verificationLineBlockHtml).find('.entered-address .address').append(enteredHtml);
	      let suggestedHtml = addressDisplay.createAddressVerificationDisplay(extendedSuggest, 'tmpl_multi_address_verification_display_addr_element');
	      $(verificationLineBlockHtml).find('.suggested-address .address').append(suggestedHtml);
	      $(verificationLineBlockHtml).find('.suggested-address input').attr('checked', 'checked');
        }
        $(verificationModal).find('#address-verify-form').append(verificationLineBlockHtml);
      });
      return verificationModal;
    },
    showMultiAddressVerificationModal: function(addressObj, callback) {
      let modalBody = CAddressVerification.buildMultiAddressVerificationModal(addressObj);
      COSTCO.dialog.modalStack({
        title: addressLabels.verify.modalTitle,
        body: modalBody,
        primary: addressLabels.verify.primaryButton,
        secondary: messages.JS_DIALOG_CANCEL,
        primary_event: function() {
          $('.permanent-ajax-busy').addClass('ajax-busy');
          // create final address array and pass it to callback
          let selectedInputs = $(modalBody).find('input[name^=verify]:checked');
          let finalAddressArray = [];
          $.each(selectedInputs, function(index, value) {
            let action = $(value).val();
            let addressId = $(value).attr('data-id');
            if (action === 'suggested') {
              finalAddressArray.push(CAddressVerification.findAddressById(addressId, addressObj.Validated_Address));
            } else {
              finalAddressArray.push(CAddressVerification.findAddressById(addressId, addressObj.Address));
            }
          });
          COSTCO.dialog.clearStack();
          COSTCO.dialog.close();
          if (callback) callback(finalAddressArray);
          // addressOptions.primaryEventCallback(preventhtmlajax, addressOptions, finalAddressArray);
        },
      });
    },
    /**
     * Callback function for addressForm, used for primaryEventCallback
     * @param  {[type]} preventhtmlajax [description]
     * @param  {[type]} addressOptions  [description]
     * @return {void}                 [description]
     */
    useAddressCallback: function(preventhtmlajax, addressOptions) {
      COSTCO.CAddressVerification.useAddress(preventhtmlajax, addressOptions);
    },
    setAddressEnteredForCheck: function(address){
    	var parentEl = document.body;
    	var address1 = $('#addressEnteredForCheck');
    	if(address1.length){
    		parentEl = address1.parent().get(0);
    	} else {
    		address1 = $('<INPUT TYPE="hidden" ID="addressEnteredForCheck" />').appendTo(parentEl);
    	}
    	var address2 = $('#addressEnteredForCheck2');
    	if(!address2.length){
    		address2 =  $('<INPUT TYPE="hidden" ID="addressEnteredForCheck2" />').appendTo(parentEl);
    	}
    	var city = $('#addressEnteredForCheckCity');
    	if(!city.length){
    		city =  $('<INPUT TYPE="hidden" ID="addressEnteredForCheckCity" />').appendTo(parentEl);
    	}
    	var state = $('#addressEnteredForCheckState');
    	if(!state.length){
    		state =  $('<INPUT TYPE="hidden" ID="addressEnteredForCheckState" />').appendTo(parentEl);
    	}
    	var postalCode = $('#addressEnteredForCheckPostalCode');
    	if(!postalCode.length){
    		postalCode =  $('<INPUT TYPE="hidden" ID="addressEnteredForCheckPostalCode" />').appendTo(parentEl);
    	}
    	address1.val(address.line1);
    	address2.val(address.line2);
    	city.val(address.city);
    	state.val(address.state);
    	postalCode.val(address.zip);
    },
    useAddress: function(preventhtmlajax, addressOptions, action) { 
    	var verifiedAddress;
    	var message = action;
	    if($('input[name=verify]:checked').val() != undefined){
			action = $('input[name=verify]:checked').val();
	    }
	    window.digitalDataEvents = window.digitalDataEvents || [];
	    if (action == 'suggested') {
	  	  verifiedAddress = COSTCO.CAddressVerification.suggested;	  	
	  	  digitalDataEvents.push( { ui:"Address Verification Modal | Use Address |  Suggested  Address" } );
	    } else {
			verifiedAddress = COSTCO.CAddressVerification.entered;
      digitalDataEvents.push( { ui:"Address Verification Modal | Use Address | Entered Address"  } );
			// SFSTRY0034758 - Use 9 digit zip code if AddressDoctor suggestion matches address
			if (COSTCO.CAddressVerification.suggested !== 'undefined' && COSTCO.CAddressVerification.suggested !== '') {
				if (COSTCO.CAddressVerification.suggested.zip.substring(0, 5) === COSTCO.CAddressVerification.entered.zip.substring(0, 5)) {
					verifiedAddress.zip = COSTCO.CAddressVerification.suggested.zip;
				}
			}
			//Save suggested isCommercial(RDI) flag if available, even if user selects entered address:
			if($('input[name=verify]:checked').val() != undefined) {
				verifiedAddress.isCommercial = COSTCO.CAddressVerification.suggested.isCommercial;
			}
		}
	    COSTCO.CAddressVerification.suggested = '';
	    COSTCO.CAddressVerification.setAddressEnteredForCheck(verifiedAddress);
	    address.addEditAddress(verifiedAddress, preventhtmlajax, addressOptions,message);
	},
    handleRadioButtonClick: function(element) {
    	let passiveElementParent = $(element).parent().attr('id') === "suggested-address" ? $('#entered-address') : $('#suggested-address');
			COSTCO.CAddressVerification.setRadioAttributes($(element), passiveElementParent);
      $('#costcoModalBtn2').removeClass('btn-disabled');
    },
    addressVerification: function(addressArray, type, preventajaxhtml, addressOptions) {
      $('.order-ajax').addClass('ajax-busy');
      let _dataType = 'json';
      let _data = {};
      _data['formdata'] = encodeURIComponent(JSON.stringify(addressArray));
				$.ajax({
					url: '/AjaxAddressVerificationCmd',
					type: 'POST',
					dataType: _dataType,
			        data: _data,
					timeout: 15000
      }).done(function(addressObj) {
        addressOptions.successCallback(addressObj, type, preventajaxhtml, addressOptions);
      }).fail(function(addressObj) { // Timeout or error sets verifiedAddress to inputted array
        // Error Calling Verification Service
    	  console.log('Verification Address : ' + JSON.stringify(addressObj));
      }).always(function() {
			$('.order-ajax').removeClass('ajax-busy');
      });
    },
    extractValidatedAddress: function(addressObj, type) {
      console.log('Extracting Validated Address : ' + JSON.stringify(addressObj));
      let suggested = addressObj.Validated_Address[0];
      let entered = addressObj.Address[0];
      suggested.fName = entered.fName;
      suggested.lName = entered.lName;
      suggested.company = entered.company;
      suggested.pNumber = entered.pNumber;
      suggested.ext1 = entered.ext1;
      suggested.nickname = entered.nickname;
      suggested.saveAddress = entered.saveAddress;
      suggested.setDefault = entered.setDefault;
      suggested.addressType = type;
      suggested.addressType2 = entered.addressType2;
      suggested.mInitial = entered.mInitial;
      suggested.email = entered.email;
      suggested.deliveryInst = entered.deliveryInst;
      suggested.contactName = entered.contactName;
      suggested.contactPhNo = entered.contactPhNo;
      return suggested;
    },
    isSuggestedSameAsEntered: function(addressObj) { // web service down or service reports address suggestion for correctly entered address
      let suggested = addressObj.Validated_Address[0];
      let entered = addressObj.Address[0];
      if (suggested.result != 'ADDRESS_WRONG_NO_SUGGESTION' && suggested.line1.toUpperCase() === entered.line1.toUpperCase() && suggested.line2.toUpperCase() === entered.line2.toUpperCase() && suggested.city.toUpperCase() === entered.city.toUpperCase() && suggested.state === entered.state && suggested.zip.substring(0, 5) === entered.zip.substring(0, 5) && suggested.country === entered.country) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * Builds one element of the AVS request object array
     * @param  {Object} form jquery form object which contains fields of address to be verified
     * @param  {Object} selectors JSON object containing selectors that should be used in the form to get data from form to build request
     * @return {Object} One element of the array to be passed to AVS service
     */
    buildRequestElement: function(form, selectors) {
      let addressObject = {
        id: ($(form).find(selectors.id).val() ? $(form).find(selectors.id).val() : ''),
        label: $(form).find(selectors.label).val() || $(form).find(selectors.label).text(),
        line1: $(form).find(selectors.line1).val(),
        line2: $(form).find(selectors.line2).val(),
        line3: $(form).find(selectors.line3).val(),
        city: $(form).find(selectors.city).val(),
        state: $(form).find(selectors.state).val(),
        country: $(form).find(selectors.country).val(),
        zip: $(form).find(selectors.zip).val(),
        fName: ($(form).find(selectors.fName).length > 0 ? $(form).find(selectors.fName).val() : ''),
        lName: ($(form).find(selectors.lName).length > 0 ? $(form).find(selectors.lName).val() : ''),
      };
      return addressObject;
    },
    /**
     * Match validated address with entered address by label.
     * @param {String} label Label of the entered address
     * @param {Array} validatedAddresses Array or validated addresses returned by AVS
     * @return matched address by label
     */
    matchValidatedAddress: function(id, validatedAddresses) {
      let validatedAddress = null;
      $.each(validatedAddresses, function(index, value) {
        if (id == value.id) {
          validatedAddress = value;
          return false;
        }
      });
      return validatedAddress;
    },
    /**
     * Iterate through input address array and match address by id param.
     * @param {String} id id of the address to be matched
     * @param {Array} addresses Array of addresses in which we need to find one by id
     * @return {Object} Matched address
     */
    findAddressById: function(id, addresses) {
      let matchedAddress = {};
      $.each(addresses, function(index, value) {
        if (value.id == id) {
          matchedAddress = addresses[index];
          return false;
        }
      });
      return matchedAddress;
    },
    /**
     * Takes an array of verified addresses and determines if any of them
     * have returned with a result of 'NO_SUGGESTION'.
     * @param  {Array} addresses The array of addresses to check.
     * @return {boolean}
     */
    hasAnyNoSuggestion: function(addresses) {
      return COSTCO.util.any(addresses, (address) => {
        return address.result.includes('NO_SUGGESTION');
      });
    },
    /**
     * Takes an array of verified addresses and determines if all of them have
     * returned with a result of 'NO_SUGGESTION'.
     * @param  {Array} addresses The array of addresses to check.
     * @return {boolean}
     */
    hasAllNoSuggestion: function(addresses) {
      return COSTCO.util.all(addresses, (address) => {
        return address.result.includes('NO_SUGGESTION');
      });
    },
    /**
     * Takes an address object returned from the address verification service
     * and determines if all of the entered addresses match all of the suggested
     * addresses.
     * @param  {Object} addressObj The address object returned from AV
     * @return {boolean}           Are all entered == suggested?
     */
    hasAllSameAsSuggested: function(addressObj) {
      let result = true;
      for (let i = 0; i < addressObj.Address.length; i++) {
        // To reuse isSuggestedSameAsEntered, need this data structure.
        // This assumes we always have 1:1 entered:validated in the addressObj
        let tempObj = {
          Address: [addressObj.Address[i]],
          // ensure we have the matching validated address
          Validated_Address: [
            this.findAddressById(addressObj.Address[i].id,
              addressObj.Validated_Address),
          ],
        };
        if (this.isSuggestedSameAsEntered(tempObj)) {
          continue;
        } else {
          result = false;
          break;
        }
      }
      return result;
    },
    /**
     * Displays the new Adress Type modal so that the user sets the address type (if in BD Truck zone)
     * @param  {String}    form - submitted form element
    */
    viewAddressTypeModal: function(preventhtmlajax, addressOptions, message, data){
      COSTCO.dialog.createExtDialogBox({
        title : messages.DELIVERY_OPTIONS,
        body: COSTCO.util.tmpl('tmpl_delivery_address_modal'),
        primary : messages.SET_DELIVERY_METHOD,
        popover : true,
        dialogclasses: 'nd-delivery-method-dialog',
        onshow: function() {
			$('#delivery_address_modal_form').append($('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset'));
			$('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset').remove();
//			$('.nd-delivery-method-dialog #costcoModalBtn2').attr("data-bi-tc", "ui:Browse | Choose Delivery Method | Set Delivery Method")
			
		},
		onclose: function() {
//			$(document).unbind('click', COSTCO.zipCodeModal.showErrorOnClickOutsideModal);
			$('#nd-zipcode-method-modal-body').append($('#delivery_address_modal_form #nd-zipcode-method-fieldset'));
			$('#delivery_address_modal_form #nd-zipcode-method-fieldset').remove();
		},
        primary_event: function(){
            if(document.querySelector('input[name="nd-radio-group-input"]:checked') == null) {
                $('.addresstype-setup-notification').removeClass("hidden");
                $('.addresstype-setup-notification').find("div").html(messages.ERR_DELIVERY_METHOD_NOT_SELECTED);
            } else {
                if(message == "suggested") {
                    COSTCO.CAddressVerification.suggested.showAddressTypePopup = false;
                } else if(data != undefined) {
                    data.showAddressTypePopup = false;
                } else {
                    COSTCO.CAddressVerification.entered.showAddressTypePopup = false;
                }
                COSTCO.CAddressVerification.useAddress(preventhtmlajax, addressOptions,message);
            }
        }
      });	
      $('.close').addClass("hidden");
    },
	validateShowAddressTypeModal: function(verifiedAddress,addressOptions){
		return (verifiedAddress.showAddressTypePopup == "true"
				&&(addressOptions.addressBookReinit == undefined || addressOptions.addressBookReinit == false)
				&& verifiedAddress.addressType == 'S'
				&& (addressOptions.validateParams == undefined || (addressOptions.validateParams != undefined &&(verifiedAddress.line1!=addressOptions.validateParams[0] || verifiedAddress.zip!=addressOptions.validateParams[1] || verifiedAddress.city!=addressOptions.validateParams[2]))))
	},
	handleRadioButtonEnterKey: function(element){
		if(event.keyCode === 13){
			$(element).parent().siblings().find('input').get(0).removeAttribute('checked');
			$(element).parent().siblings().find('div:first').get(0).removeAttribute('aria-checked');
			$(element).children().get(0).setAttribute('checked', 'true');
			$(element).get(0).setAttribute('aria-checked', 'true');
			$('#costcoModalBtn2').removeClass('btn-disabled');
		}
	},
	handleRadioButtonSpaceKey: function(element){
		if(event.keyCode === 32){
			element.click();
			$('#costcoModalBtn2').removeClass('btn-disabled');
		}
	},
	
	setRadioAttributes: function(activeElement, passiveElementParent) {
		let passiveInput = passiveElementParent.find('input').get(0);
		if (typeof(passiveInput) !== 'undefined') {
			passiveInput.removeAttribute('checked');
		}
		
		let passiveLabel = passiveElementParent.find('label').get(0);
		if (typeof(passiveLabel) !== 'undefined') {
			passiveLabel.removeAttribute('aria-checked');
		}
		
		// set attr checked on input
		let activeInput = activeElement.find('input').get(0);
		if (typeof(activeInput) !== 'undefined') {
			activeInput.setAttribute('checked', 'true');
		}
		
		// set attr aria-checked on label
		let activeElem = activeElement.get(0);
		if (typeof(activeElem) !== 'undefined') {
			activeElem.setAttribute('aria-checked', 'true');
		}
	},
	/**
	* Displays the new Delivery Method modal so that the user sets the delivery method
	* @param  {String}    form - submitted form element
	*/
    viewDeliveryMethodModal: function (form, data, params, oldAddy, newAddy) {
      var showQuestionnaireModal = false;
      COSTCO.dialog.createExtDialogBox({
        title : messages.DELIVERY_OPTIONS,
        body: COSTCO.util.tmpl('tmpl_delivery_address_modal'),
        primary : messages.SET_DELIVERY_METHOD,
        popover : true,
        dialogclasses: 'nd-delivery-method-dialog',
        onshow: function() {
          $('#delivery_address_modal_form').append($('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset'));
          $('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset').remove();
          $('.nd-delivery-method-dialog #costcoModalBtn2').attr("data-bi-tc", "ui:Checkout | Choose Delivery Method | Set Delivery Method")
          $('.addresstype-setup-notification').addClass("hidden");
          $('.addresstype-setup-notification').find("div").html('');
          
          if (data.isBDTruckZoneEnabledForWareHouse === true) {
              $("#nd-local-delivery-modal-section").removeClass("hidden");
          } else {
              $("#nd-local-delivery-modal-section").addClass("hidden");
          }
          
          if (data.isNationalDeliveryEnabledForWareHouse === true) {
              $("#nd-nationwide-delivery-modal-section").removeClass("hidden");
          } else {
              $("#nd-nationwide-delivery-modal-section").addClass("hidden");
          }   
          
          if (data.isStorePickupEnabledForWareHouse === true) {
              $("#store-pickup-modal-section").removeClass("hidden");
          } else {
              $("#store-pickup-modal-section").addClass("hidden");
          }
                 
          $('#nd-local-delivery-radio-button').focus();
        },
        onclose: function() {
          $(document).unbind('click', COSTCO.zipCodeModal.showErrorOnClickOutsideModal);
          if ($('#nd-zipcode-method-modal-body').children('fieldset').length == 0) {
             $('#nd-zipcode-method-modal-body').append($('#delivery_address_modal_form #nd-zipcode-method-fieldset'));
          }
          $('#delivery_address_modal_form #nd-zipcode-method-fieldset').remove();
        },
        primary_event: function () {
          if(document.querySelector('input[name="nd-radio-group-input"]:checked') == null) {
            $('.addresstype-setup-notification').removeClass("hidden");
            $('.addresstype-setup-notification').find("div").html(messages.ERR_DELIVERY_METHOD_NOT_SELECTED);
            
            var isFocusSet = false;
            if (data.isBDTruckZoneEnabledForWareHouse === true) {
              $('#nd-local-delivery-radio-button').focus();
              isFocusSet = true;
            } 
            
            if (data.isNationalDeliveryEnabledForWareHouse === true && isFocusSet == false) {
              $('#nd-nationwide-delivery-radio-button').focus();
              isFocusSet = true;
            } 
            
            if (data.isStorePickupEnabledForWareHouse === true && isFocusSet == false) {
              $('#store-pickup-radio-button').focus();
            }
            
          } else {
            var deliveryMehod;
            if ($('input[name="deliveryMethod"]').length > 0) {
              deliveryMethod = $("input[name='deliveryMethod']:checked").val();
            }
            var selectedDeliveryMethod = 'Local';
            if (document.querySelector('input[name="nd-radio-group-input"]:checked')!=null) {
              var uiSelectedDeliveryMethod = document.querySelector('input[name="nd-radio-group-input"]:checked').value;
              switch(uiSelectedDeliveryMethod) {
                case "C":
                  selectedDeliveryMethod = "Local";
                  break;
                case "R":
                  selectedDeliveryMethod = "Nationwide";
                  break;
                case "P":
                  selectedDeliveryMethod = "Store-Pick-Up";
                  break;
              }
              $(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val(selectedDeliveryMethod);
            }
            window.digitalDataEvents = window.digitalDataEvents || [];
            if (selectedDeliveryMethod === 'Local') {
              digitalDataEvents.push({
                browseDeliveryMethod:"Local Business Delivery"
              });
            } else if (selectedDeliveryMethod === 'Nationwide') {
              digitalDataEvents.push({
                browseDeliveryMethod:"Nationwide Delivery"
              });
            }
            data.userSelectionDeliveryMethod = selectedDeliveryMethod;
            if (oldAddy == null) {//add address flow
              COSTCO.CAddress.callAddressAddNew(params[2], params[3], newAddy, params[4], data);
            } else {
              COSTCO.CAddress.callChooseAddressNew(params[2], oldAddy, newAddy, data);
            }
          }
          var espot = $('#delivery_address_modal_form #nd-zipcode-method-fieldset').clone();
          $('#nd-zipcode-method-modal-body').html(espot);
        }
      });	
      $('.close').addClass("hidden");
    },
	
  };
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.CAddressVerification = CAddressVerification;
  return CAddressVerification;
});



// WEBPACK FOOTER //
// ./js/address/addressVerification.js